import React, { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';

interface SchemaNodeData {
  table_name: string;
  table_comment: string;
  key_columns: Array<{ name: string; type: 'PK' | 'FK' }>;
}

/**
 * ER 图自定义表节点 — 展示表名 + PK/FK 字段
 */
function SchemaNodeComponent({ data }: NodeProps & { data: SchemaNodeData }) {
  return (
    <div className="bg-card border border-border rounded-md min-w-[180px] text-[13px] shadow-[var(--shadow-4)]">
      <Handle type="target" position={Position.Left} />

      {/* 表头 */}
      <div className="bg-primary text-primary-foreground px-2.5 py-1.5 rounded-t-md font-semibold text-[13px]">
        {data.table_name}
        {data.table_comment && (
          <div className="text-[11px] opacity-80 font-normal">{data.table_comment}</div>
        )}
      </div>

      {/* 字段列表 */}
      <div className="py-1">
        {data.key_columns.map((col, i) => (
          <div
            key={`${col.name}-${col.type}-${i}`}
            className={`px-2.5 py-0.5 flex justify-between items-center font-mono text-xs ${
              i < data.key_columns.length - 1 ? 'border-b border-border/50' : ''
            }`}
          >
            <span>{col.name}</span>
            <span className={`text-[10px] px-1 rounded font-semibold ${
              col.type === 'PK'
                ? 'bg-amber-100 text-amber-800'
                : 'bg-blue-100 text-blue-800'
            }`}>
              {col.type}
            </span>
          </div>
        ))}
        {data.key_columns.length === 0 && (
          <div className="px-2.5 py-0.5 text-muted-foreground text-xs">无关键字段</div>
        )}
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  );
}

export default memo(SchemaNodeComponent);
